module.exports = __webpack_public_path__ + "static/media/ic_downloadOrange.3a87f2e6.svg";